import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { Link } from "@backstage/core-components";
import { useRouteRef } from "@backstage/core-plugin-api";
import { forgePlugin } from "@internal/plugin-forge";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import { useRootStyles } from "../../styles/useRootStyles";

interface ForgeNavItemProps {
  mobile?: boolean;
  onClick?: () => void;
}

export const ForgeNavItem = ({
  mobile = false,
  onClick,
}: ForgeNavItemProps) => {
  const forgePath = useRouteRef(forgePlugin.routes.root);
  const classes = useRootStyles();

  if (!forgePath) {
    return null;
  }

  if (mobile) {
    return (
      <ListItem
        button
        component={Link}
        to={forgePath()}
        className={classes.drawerItem}
        onClick={onClick}
      >
        <ListItemIcon className={classes.drawerIcon}>
          <WhatshotIcon />
        </ListItemIcon>
        <ListItemText primary="Forge" />
      </ListItem>
    );
  }

  return (
    <Button
      component={Link}
      to={forgePath()}
      className={classes.navButton}
      startIcon={<WhatshotIcon />}
      color="inherit"
    >
      Forge
    </Button>
  );
};
